export class BdModalContent {
    constructor(public title?: string, public body1?: string, public body2?: string) {
    }
}
